/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SessionScanCompletedSessionIdGet$Params {

/**
 * The session ID to check
 */
  sessionId: string;
}

export function sessionScanCompletedSessionIdGet(http: HttpClient, rootUrl: string, params: SessionScanCompletedSessionIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, sessionScanCompletedSessionIdGet.PATH, 'get');
  if (params) {
    rb.path('sessionId', params.sessionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as VivaLiteScanStrictHttpResponse<boolean>;
    })
  );
}

sessionScanCompletedSessionIdGet.PATH = '/Session/ScanCompleted/{sessionId}';
